<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :bodyStyle="bodyStyle"
    :confirmLoading="confirmLoading"
    :footer="null"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: (disableSubmit)} }"
    cancelText="关闭">
    <a-card  title="标的简介">
      <JEditor :disabled='disableSubmit' :readOnly="disableSubmit" v-model="jeditor.value" id="editorCentent" ></JEditor>
    </a-card>
    <div class="ant-modal-footer">
      <div>
        <a-button class="ant-btn" :loading="confirmLoading"  @click="beforeStep"><span>上一步</span></a-button>
        <a-button type="primary" :loading="confirmLoading"  class="ant-btn ant-btn-primary" @click="handleOk3"><span>下一步</span></a-button>
        <a-button class="ant-btn" @click="handleCancel"><span>取消</span></a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";
import moment from "moment/moment";
import {downloadFile, getAction, postAction} from "@api/manage";
import {FzisListMixin} from "@/mixins/FzisListMixin";
import ProjectLandAddLandModal from "@views/earthmine/modules/ProjectLandAddLandModal.vue";
import pick from "lodash.pick";

export default {
  name: "SubjectStep3Modal",
  components: {ProjectLandAddLandModal},
  mixins:[FzisListMixin],
  data () {
    return {
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      title: "操作",
      bodyStyle:{
        padding: "0",
        overflow:"auto",
        // height:(window.innerHeight-100)+"px"
        height:"500px"
      },
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      id:"",
      model:{},
      jeditor:{
        value:""
      },
      url: {
        addOrUpdate: "/ebid-ce/propertyright/prSubjectTransfer/addOrUpdate",
      },
      modal:{},
    }
  },
  computed: {
  },
  methods:{
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      this.visible = false;
    },
    beforeStep () {
      this.visible = false;
      this.$emit('beforeStep','2',this.model);
    },
    //编辑
    edit(record)
    {
      this.visible = true;
      this.model=record;
      console.log("modelmodelmodelmodel",this.model);
      this.jeditor.value=this.model.introduction;
    },
    //保存
    handleOk3(){
      if(this.disableSubmit)
      {
        this.model.disableSubmit=this.disableSubmit;
        this.$emit('nextStep','4',this.model);
        return;
      }

      const that = this;
      let formData = this.model;
      that.confirmLoading=true;
      formData.personList=[];
      formData.introduction=this.jeditor.value;
      postAction(that.url.addOrUpdate,formData).then(res => {
        if (res.success) {
          formData.id=res.result;
          that.$emit('nextStep','4',formData);
          that.$emit('loadData');
          return;
        }
        else
        {
          that.$message.error(res.message);
        }
      }).finally(() => {
        that.confirmLoading=false;
      });
    }
  }
}
</script>

<style scoped>
.labelTop{
  margin-top: 10px;
  text-align: right;
  color:#262626;
}
</style>